export default __webpack_public_path__ + "media/flavours/glitch/images/glitch-preview-29f7c85e93ec77217ab5b6c3cde957eb.jpg";